import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth, useTokenPurchaseModal } from '../context/AuthContext';
import BrutalistButton from './BrutalistButton';
import ConfirmAbandonModal from './test/ConfirmAbandonModal';
import ThemeToggle from './ThemeToggle';
import styles from '../styles/Header.module.css';

const Header = () => {
  const { isDarkMode } = useTheme();
  const { isAuthenticated, showPurchaseModal } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const isTestPage = location.pathname.includes('/test') ||
                     location.pathname.includes('/modulos') ||
                     location.pathname.includes('/repaso');
  
  // Hide header on test pages
  if (isTestPage) {
    return null; // Don't render header on test pages
  }
  
  return (
    <header className={`${styles.header} ${isHomePage ? styles.homeHeader : ''}`}>
      {!isHomePage && (
        <BrutalistButton
          to="/"
          className={styles.headerNav}
        >
          🏠 INICIO
        </BrutalistButton>
      )}

      <div className={styles.authButtons}>
        {!isAuthenticated && (
          <BrutalistButton
            onClick={showPurchaseModal}
            className={styles.headerNav}
          >
            OBTENER TOKEN GRATUITO
          </BrutalistButton>
        )}
        <BrutalistButton
          to="/acceso-autoescuela"
          className={styles.headerNav}
        >
          ACCESO AUTOESCUELAS
        </BrutalistButton>
      </div>
      
      {/* Theme toggle button */}
      <ThemeToggle />
    </header>
  );
};

export default Header;